import styled from "@emotion/styled";
import React from "react";
import theme from "../../../assets/theme";
import FlexContainer from "../../../components/containers/FlexContainer";
import PageContainer from "../../../components/containers/PageContainer";
import VersionContainer from "../../../domains/softVersion/VersionContainer";
import LoginBackground from "./../../../assets/img/login-background.png";
import NavBarLogo from "./../../../assets/img/navBarLogo.png";

export const LoginPageContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: ${props => props?.color || theme.palette.background.default};
  transition: "background-color 0.5s ease";
  background-image: url(${LoginBackground});
  background-blend-mode: luminosity;
  background-size: cover;
  background-position: center;
  filter: grayscale;
`;

const LoginFormPage = styled(LoginPageContainer)`
  width: 100%;
  height: auto;
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
`;

export type LoginCardSize = "sm" | "md";

/** Card width per size. Login stays at the original "sm"; the recovery/reset
 *  flows use "md" so their taller content (password rules, etc.) has room. */
const CARD_WIDTH: Record<LoginCardSize, string> = {
  sm: "300px",
  md: "420px",
};

const LoginCard = styled(PageContainer)`
  height: ${({ height }) => height};
  width: ${({ width }) => width || "300px"};
  max-width: 100%;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  border-radius: 8px;
  background: ${theme.palette.background.paper};

  ${theme.breakpoints.down("xs")} {
    padding: 16px 8px;
  }
`;
export const Logo = styled("img")`
  height: 90px;
  margin: auto;
`;

const LoginFormContainer: React.FC<{ size?: LoginCardSize }> = ({ children, size = "sm" }) => {
  return (
    <LoginFormPage>
      <LoginCard width={CARD_WIDTH[size]}>
        <FlexContainer justify={"center"} height={"100px"}>
          <a target="link" href="http://tgdcompany.com">
            <Logo src={NavBarLogo} />
          </a>
        </FlexContainer>

        {children}
      </LoginCard>

      <VersionContainer company="TGD" justify="center" />
    </LoginFormPage>
  );
};

export default LoginFormContainer;
